import { ArtistType } from '../types'

export const ARTIST_TYPE_DISPLAY_NAMES = {
  [ArtistType.SoloArtist]: 'Individual Artist',
  [ArtistType.Band]: 'Band',
}
